import defaultV2Client from '@/plugins/axios/defaultV2Client'

export default {
  /**
   *
   * @param {
   *   phone: phone,
   * } query
   * @returns
   */
  onlyPhoneDuplicate(phone) {
    return defaultV2Client.get(`/signup/phone-duplicate?phone=${phone}`)
  },
}
